import { getExperimentValue } from '@/utilities/logger/amplitude/experiments/getExperimentValue';

/**
 * Default enabling variants across the app. Amplitude experiments use either the
 * `'on'`/`'off'` or `'treatment'`/`'control'` naming convention, so both `'on'`
 * and `'treatment'` count as enabled unless a caller narrows the list.
 */
export const DEFAULT_ENABLED_VARIANTS = ['on', 'treatment'] as const;

/**
 * True when the given experiment resolves to an enabling variant.
 *
 * Generic over any experiment key so features can gate on a flag without a
 * bespoke helper. Pass `enabledVariants` to override the default set.
 */
export const isExperimentEnabled = (
  experiments: Record<string, unknown> | null | undefined,
  key: string,
  enabledVariants: readonly string[] = DEFAULT_ENABLED_VARIANTS,
): boolean => {
  const value = getExperimentValue(experiments, key);
  return value !== undefined && enabledVariants.includes(value);
};
